import { UiState } from 'instantsearch.js';
import { debounce } from 'lib/util/debounce';

declare global {
  interface Window {
    dataLayer: Array<Record<string, unknown>>;
  }
}

const searchIndex = process.env.ALGOLIA_INDEX_NAME || '';

export function googleAnalyticsMiddleware() {
  const {
    debouncedFn: sendEventDebounced,
    cancel: cancelDebouncedEvent,
    isActive: isDebouncedEventActive,
  } = debounce((uiState: UiState) => {
    if (window.dataLayer) {
      const searchState = uiState[searchIndex];
      if (searchState) {
        const { query, menu } = searchState;
        if (query) {
          window.dataLayer.push({
            event: 'nmdp_custom_search',
            nmdp_search_term: query,
            nmdp_search_type: menu?.type,
          });
        }
      }
    }
  }, 3000);

  return {
    onStateChange({ uiState }: { uiState: UiState }) {
      if (isDebouncedEventActive()) {
        cancelDebouncedEvent();
      }
      sendEventDebounced(uiState);
    },
    subscribe() {
      // kept comment to avoid lint error
    },
    unsubscribe() {
      cancelDebouncedEvent();
    },
  };
}
